// StakingRoom.styles.js

const styles = {
    container: {
      maxWidth: 960,
      margin: 'auto',
      padding: '20px 15px',
      fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
      color: '#2c3e50',
      lineHeight: 1.5,
      
    },
     header: { position: 'relative', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '12px', padding: '1rem', backgroundColor: '#f5f5f5',color: '#333', borderRadius: '8px', boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)', marginBottom: '20px' },
  welcome: { fontSize: '1.2rem', marginBottom: '0.5rem', flex: '1 1 100%', textAlign: 'center' },
 
  
    sectionTitle: {
      fontSize: 24,
      marginBottom: 16,
      fontWeight: '700',
      color: '#34495e',
      borderBottom: '2px solid #2980b9',
      paddingBottom: 8,
    },
  
    summarySection: {
      marginBottom: 30,
      backgroundColor: '#f0f4f8',
      borderRadius: 12,
      padding: 20,
      boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
      display: 'flex',
      flexDirection: 'column',
      gap: 15,
      maxWidth: 800,
    },
  
    controlsSection: {
      display: 'flex',
      flexWrap: 'wrap',
      gap: 20,
      justifyContent: 'space-between',
      marginBottom: 30,

    },

    controlCardContainer: {
      display: 'flex',
    flex: '1 1 300px',   
      flexWrap: 'wrap',
      justifyContent: 'space-between',
      marginBottom: 10,
      boxShadow: '0 2px 10px rgba(0,0,0,0.12)',
minWidth: 100,
       padding: '5px, 20px',
       
 

    },
  
    controlCard: {
      flex: '1 1 300px',
      backgroundColor: '#fff',
      borderRadius: 12,
      padding: 20,
      boxShadow: '0 2px 10px rgba(0,0,0,0.12)',
      display: 'flex',
      flexDirection: 'column',
      gap: 12,
      minWidth: 100,
    },
  
    controlTitle: {
      fontSize: 16,
      fontWeight: '400',
      color: '#34495e',
      marginBottom: 10,
    },
  
    input: {
      padding: '12px 15px',
      fontSize: 16,
      borderRadius: 8,
      border: '1.5px solid #bdc3c7',
      outline: 'none',
      transition: 'border-color 0.25s ease',
      width: '100%',
      boxSizing: 'border-box',
    },
  
    buttonGroup: {
      display: 'flex',
      gap: 12,
    },
  
    button: {
      flex: '1',
      padding: '12px 18px',
      borderRadius: 8,
      border: 'none',
      fontWeight: '400',
      fontSize: 14,
      cursor: 'pointer',
      transition: 'background-color 0.3s ease, box-shadow 0.2s ease',
      userSelect: 'none',
      boxShadow: '0 2px 6px rgba(0,0,0,0.15)',
    },
  
    blueButton: { backgroundColor: '#2980b9', color: '#fff' },
    greenButton: { backgroundColor: '#27ae60', color: '#fff' },
    orangeButton: { backgroundColor: '#e67e22', color: '#fff' },
    purpleButton: { backgroundColor: '#9b59b6', color: '#fff' },
    redButton: { backgroundColor: '#c0392b', color: '#fff' },
  
    transferSection: {
      backgroundColor: '#f9f9f9',
      borderRadius: 12,
      padding: 25,
      boxShadow: '0 2px 12px rgba(0,0,0,0.1)',
      maxWidth: 420,
      margin: '0 auto 30px',
      display: 'flex',
      flexDirection: 'column',
      gap: 15,
    },
  
    chartSection: {
      marginBottom: 30,
      padding: 20,
      backgroundColor: '#fff',
      borderRadius: 12,
      boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
    },
  
    leaderboardSection: {
      maxWidth: 500,
      margin: 'auto',
      marginBottom: 40,
    },
  
    leaderboardToggleButton: {
      width: '100%',
      backgroundColor: '#34495e',
      color: '#fff',
    },
  
    leaderboardContainer: {
      marginTop: 15,
      maxHeight: 400,
      overflowY: 'auto',
      border: '1px solid #ddd',
      borderRadius: 12,
      backgroundColor: '#fff',
      boxShadow: '0 2px 12px rgba(0,0,0,0.08)',
    },
  
    leaderboardItem: {
      display: 'flex',
      alignItems: 'center',
      padding: '12px 18px',
      borderBottom: '1px solid #eee',
    },
  
    avatar: {
      width: 48,
      height: 48,
      borderRadius: '50%',
      marginRight: 15,
      objectFit: 'cover',
      border: '2px solid #2980b9',
    },
  
    leaderboardText: {
      flex: 1,
      fontSize: 15,
      color: '#34495e',
    },
  
    rank: {
      fontWeight: '700',
      fontSize: 14,
      color: '#7f8c8d',
    },
  
    modalMessage: {
      position: 'fixed',
      top: 20,
      right: 20,
      padding: '14px 22px',
      backgroundColor: '#e74c3c',
      color: '#fff',
      borderRadius: 10,
      cursor: 'pointer',
      boxShadow: '0 6px 16px rgba(0,0,0,0.25)',
      maxWidth: 320,
      zIndex: 10000,
      userSelect: 'none',
      fontWeight: '600',
    },
  };
  
  export default styles;
  